/**
 * Emergency-contact relationship options for Add/Edit Person forms.
 * Kept in one place so the Add and Edit pages cannot drift apart.
 */
export const EMERGENCY_CONTACT_RELATIONSHIPS: string[] = [
  "Mother",
  "Father",
  "Spouse",
  "Partner",
  "Brother",
  "Sister",
  "Son",
  "Daughter",
  "Uncle",
  "Aunt",
  "Cousin",
  "Caretaker",
  "Neighbour",
  "Friend",
];

/** Combobox-ready form of the list above (label === value). */
export const EMERGENCY_CONTACT_RELATIONSHIP_OPTIONS = EMERGENCY_CONTACT_RELATIONSHIPS.map(
  (relationship) => ({ label: relationship, value: relationship })
);
